import { StandardEvents } from '@shopify/events';
import { formatMoney } from '@theme/money-formatting';

/**
 * Shows the sitewide "Added to My Bag" modal after any add-to-cart action,
 * populated from the same cart update event the header's cart bubble and
 * cart drawer already listen to. Only reacts to `action: 'add'` — quantity
 * changes made from the cart page or drawer don't open it.
 */
class CartAddedModal {
  constructor(root) {
    this.root = root;
    this.imageEl = root.querySelector('[data-cart-added-image]');
    this.titleEl = root.querySelector('[data-cart-added-title]');
    this.priceEl = root.querySelector('[data-cart-added-price]');
    this.qtyEl = root.querySelector('[data-cart-added-qty]');
    this.viewBagButton = root.querySelector('[data-cart-added-view-bag]');

    this.moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    this.currency = root.dataset.currency || 'USD';
    this.cartUrl = root.dataset.cartUrl || '/cart';
    this.cartType = root.dataset.cartType;

    this.viewBagButton?.addEventListener('click', this.onViewBag);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
  }

  onViewBag = () => {
    this.root.closeDialog?.();

    if (this.cartType === 'drawer') {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.toggle === 'function') {
        drawer.toggle();
        return;
      }
    }

    window.location.href = this.cartUrl;
  };

  onCartUpdate = (event) => {
    if (event.action !== 'add') return;

    const merchandiseId = event.lines?.[0]?.merchandiseId;
    const variantId = merchandiseId ? String(merchandiseId).split('/').pop() : null;

    event.promise
      ?.then(async ({ detail }) => {
        if (detail?.didError) return;

        let items = detail?.items;
        if (!items) {
          const cart = await fetch(`${this.cartUrl}.js`).then((res) => res.json());
          items = cart.items || [];
        }

        const addedItem =
          (variantId && items.find((item) => String(item.id) === variantId)) || items[items.length - 1];

        if (!addedItem) return;

        this.render(addedItem, detail.itemCount);
        this.root.showDialog?.();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[cart-added-modal] Event promise rejected:', error);
      });
  };

  render(item, addedQuantity) {
    if (this.titleEl) this.titleEl.textContent = item.product_title;
    if (this.priceEl) this.priceEl.textContent = formatMoney(item.price, this.moneyFormat, this.currency);
    if (this.qtyEl) this.qtyEl.textContent = `Qty: ${addedQuantity ?? item.quantity}`;

    if (this.imageEl) {
      if (item.image) {
        this.imageEl.src = item.image;
        this.imageEl.alt = item.product_title;
        this.imageEl.hidden = false;
      } else {
        this.imageEl.hidden = true;
      }
    }
  }
}

const modalRoot = document.getElementById('brickline-cart-added-modal');
if (modalRoot) new CartAddedModal(modalRoot);
